{
  "version": 1,
  "asset_id": "772541ac-7450-4364-8137-0be60e56fcd2",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/772541ac-7450-4364-8137-0be60e56fcd2/destination-roofing-crew-citrus-county-fl-1600.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/772541ac-7450-4364-8137-0be60e56fcd2/destination-roofing-crew-citrus-county-fl-1600.webp",
  "original_filename": "destination-roofing-crew-citrus-county-fl-1600.webp",
  "size": 171514,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:33Z"
}
